<template lang="html">
  <div>
    <form
      ref="serverForm"
      v-bind="$attrs"
      :class="{'was-validated': formWasSubmitted}"
      :action="formAction"
      method="POST"
      autocomplete="off"
      novalidate
      @submit="onFormSubmit">
      <input
        :value="csrfToken"
        type="hidden"
        name="_token">

      <My360Errors
        v-if="showErrors && showTopErrors"
        :errors="errors"
        class="mt-4"/>

      <slot
        :formWasSubmitted="formWasSubmitted"
        :errors="errors"
        :form="form"/>

      <My360Errors
        v-if="showErrors"
        :errors="errors"
        class="mt-4"/>

      <div
        v-if="displaySaveBtn"
        class="mt-4 d-flex justify-content-end">
        <button
          :class="mergedSubmitBtn.class"
          :disabled="saveDisabled"
          type="submit">
          {{ mergedSubmitBtn.text }} <i :class="mergedSubmitBtn.icon" />
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import { formBus } from './formBus'

export default {
  name: 'SurverForm',

  props: {
    form: {
      required: false,
      type: Object,
      default: () => { return {} }
    },

    submitBtn: {
      required: false,
      type: Object,
      default: () => { return {} }
    },

    formAction: {
      type: String,
      required: true
    },

    saveDisabled: {
      type: Boolean,
      required: false,
      default: () => { return false }
    },

    displaySaveBtn: {
      type: Boolean,
      required: false,
      default: () => { return true }
    },

    showTopErrors: {
      type: Boolean,
      required: false,
      default: () => { return false }
    },

    validateFromStart: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },

  data () {
    return {
      errors: {},
      formWasSubmitted: false,
      readyToValidateAfterServerBounce: false
    }
  },

  computed: {
    defaultSubmitBtn () {
      return {
        text: this.__('btn_save'),
        class: 'btn btn-primary',
        icon: 'far fa-save fa-fw'
      }
    },

    mergedSubmitBtn () {
      return {
        ...this.defaultSubmitBtn,
        ...this.submitBtn
      }
    },

    showErrors () {
      if (Object.keys(this.errors).length > 0) {
        if (this.readyToValidateAfterServerBounce) {
          return true
        }
        if (this.validateFromStart && !this.formWasSubmitted) {
          return false
        }
        return true
      }
    }
  },

  watch: {
    form: {
      handler: function (form) {
        formBus.$emit('form-updated', form)
        if (this.validateFromStart) {
          this.$nextTick(() => {
            this.validateForm()
          })
        } else if (this.formWasSubmitted || this.readyToValidateAfterServerBounce) {
          this.validateForm()
        }
      },
      deep: true
    }
  },

  mounted () {
    formBus.$emit('form-updated', this.form)
    Object.keys(this.my360FormOld).map((key) => {
      this.$set(this.form, key, this.my360FormOld[key])
    })

    if (Object.keys(this.my360FormOld).length > 0) {
      this.$nextTick(() => {
        this.readyToValidateAfterServerBounce = true
      })
    }

    this.getErrors()
  },

  methods: {
    onFormSubmit ($event) {
      this.formWasSubmitted = true

      if (!this.$refs.serverForm.checkValidity()) {
        $event.preventDefault()
        $event.stopPropagation()
        this.validateForm()
      }
    },

    validateForm () {
      var inputs = this.$refs.serverForm.elements
      Object.keys(inputs).forEach((inputKey) => {
        var prop = inputs[inputKey].getAttribute('prop') ? inputs[inputKey].getAttribute('prop') : inputs[inputKey].name
        var humanName = inputs[inputKey].getAttribute('validationName')
        if (!inputs[inputKey].validationMessage) {
          this.$delete(this.errors, prop)
        } else {
          this.$set(this.errors, prop, `[${humanName}] ${inputs[inputKey].validationMessage}`)
        }
      })
    },

    getErrors () {
      Object.keys(this.my360FormErrors).forEach((key) => {
        var errorPath = key.split('.')
        var errorPathLength = errorPath.length === 1 ? errorPath.length : errorPath.length - 1

        errorPath.forEach((path, index) => {
          if (index === 0) {
            if (!this.errors[path]) {
              this.$set(this.errors, path, {})
            }
            if (errorPathLength === 1) {
              this.$set(this.errors, path, this.my360FormErrors[key][0])
            }
          } else if (index === errorPathLength) {
            this.setObj(this.errors, key, this.my360FormErrors[key][0])
          } else {
            this.$set(this.errors[errorPath[index - 1]], path, {})
          }
        })
      })
    },

    submit () {
      this.$refs.serverForm.submit()
    },

    setObj (obj, is, value) {
      if (typeof is === 'string') {
        var rowVal = this.setObj(obj, is.split('.'), value)
        return rowVal
      } else if (is.length === 1 && value !== undefined) {
        this.$set(obj, is[0], value)
        return obj
      } else if (is.length === 0) {
        return obj
      } else {
        return this.setObj(obj[is[0]], is.slice(1), value)
      }
    }
  }
}
</script>
